import { useMutation } from '@tanstack/react-query';
import { CALCULATIONS_MUTATION_KEY } from 'services/calculations/mutationKey';

import { FinancialPerformanceApi } from '../financialPerformance.api';

export const PERFORMANCE_INVESTMENT_MUTATION_KEY = [...CALCULATIONS_MUTATION_KEY, 'performanceInvestment'] as const;

export const useGetPerformanceInvestment = () => {
  return useMutation({
    mutationKey: PERFORMANCE_INVESTMENT_MUTATION_KEY,
    mutationFn: FinancialPerformanceApi.getCalculationsOfPerformanceInvestment,
  });
};
